import React, { useState, useEffect, useContext, useMemo, useCallback } from 'react'
import { useIntl } from 'react-intl'
import { Table, UfinetBox, UfinetButton, UfinetSectionBox, formatTableFilters, tableSortValueToSortDirection } from 'ufinet-web-components'
import { AuthContext, Authority, } from 'ufinet-web-functions'
import { colsApprovedCommisions } from './ApprovedColData'
import { UseQueryApprovedCommissionsSystems, UseDownloadFileCommissionApprovedSys, UseRecalculateCommissionSys } from 'request'
import { DataTablePageEvent } from 'primereact/datatable'
import { Translation, useTranslation } from 'utils/translation/Translation'
import { CommissionSystemElement } from 'types/commissionSystemTypes'
import { faDownload, faCalculator } from '@fortawesome/free-solid-svg-icons'
import { toast } from 'react-toastify'
import { ErrorResponse } from 'types/typesAndValues'
import { useQueryCatalogCommissionSystem } from 'request/commissionSystem/catalogs-commission-system-request'
import { catalogQuery } from 'request/catalogs'

const ApprovedCommissionSystemPage = () => {
  const intl = useIntl()



  const {data: dataType} = useQueryCatalogCommissionSystem.useQueryCatalogType()
  const {data: dataCommissionType} = useQueryCatalogCommissionSystem.useQueryCatalogCommissionType()
  const {data: dataManagementType} = useQueryCatalogCommissionSystem.useQueryCatalogCommissionSystemManagementType()
  const {data: dataClientType, isLoading: isLoadingClientType} = catalogQuery.useGetClientType()




  const colsApprovedCommission = useMemo(() => 
    colsApprovedCommisions({
      intl,
      dataType,
      dataCommissionType,
      dataManagementType,
      dataClientType,
      }),
   [
    intl,
    dataType,
    dataCommissionType,
    dataManagementType,
    dataClientType,
  ])

  const translate = useTranslation()

  const authData = useContext(AuthContext)
  const roles = authData.userData?.authorities || []
  const permissions = Authority.getCommissionCmSystemPermissions(roles)

  const [selectedValues, setSelectedValues] = useState<CommissionSystemElement[]>([])
  const [paging, setPaging] = useState<any>()
  const [filterData, setFilterData] = useState<any>()
  const { data: approvedCommssion, isLoading: isLoadingApprovedCommision, refetch } = UseQueryApprovedCommissionsSystems(filterData)


  const isSelectedValues = selectedValues && selectedValues.length > 0


  const cbSuccessApprovedFile = (data: any) => {

  }


  const cbRecalculateCommission = ({ data }: any) => {
    toast.success(data.message)
    setSelectedValues([])
    refetch()
  }

  const { mutate: downloadFile, isLoading: isLoadingCommissionApprovedSys } = UseDownloadFileCommissionApprovedSys(cbSuccessApprovedFile)
  const { mutate: recalculateCommission, isLoading: isLoadingRecalculateCommissionSys, isError: isErrorRecalculate, error: errorMessage } = UseRecalculateCommissionSys(cbRecalculateCommission)



  const showToastErrMessage = () => {
    if (typeof errorMessage === 'object' && errorMessage !== null && 'errorCode' in errorMessage) {
      const errorResponse = errorMessage as ErrorResponse;
      toast.error(`${translate("ERROR.MESSAGE")} ${errorResponse.errorCode}`, { toastId: 'Error5' });

    }
  }



  useEffect(() => {
    if (approvedCommssion) {
      const parsePagination = JSON.parse(approvedCommssion?.headers['x-pagination'])
      const formattedPagination = {
        totalElements: parsePagination.totalCount,
        totalPages: parsePagination.totalPages,
        pageSize: parsePagination.pageSize,
        pageNumber: parsePagination.currentPage,
      }
      setPaging(formattedPagination)
    }
  }, [approvedCommssion])

  const onFilterClear = (): void => {
    setFilterData({})
  }

  const onFilter = (e: DataTablePageEvent): void => {
    const formattedFilters = formatTableFilters(e as any)
    setFilterData({
      ...filterData,
      ...formattedFilters
    })
  }

  const onPage = (e: DataTablePageEvent): void => {
    setFilterData({ ...filterData, pageNumber: e.page, pageSize: e.rows })
  }

  const onSort = (e: DataTablePageEvent): void => {
    const finalOrder = tableSortValueToSortDirection(e.sortOrder)
    setFilterData({
      ...filterData,
      sortField: e.sortField,
      sortOrder: finalOrder,
    })
  }


  const downloadFileApprovedPaidSys = () => {
    downloadFile(filterData)
  }

  const recalculate = () => {
    if (isSelectedValues) {
      const newArr = selectedValues.map((item: CommissionSystemElement) => {
        return {
          Id: item.commission.id
        }
      })

      recalculateCommission(newArr)

    }

  }


  const getHeadersButtons = () => (
    <>

      {permissions.canWrite && (
        <UfinetButton
          className="me-3"
          icon={faDownload}
          onClick={() => downloadFileApprovedPaidSys()}
          content={Translation('DOWNLOAD.FILE')}
        />
      )}

      {permissions.canWrite && isSelectedValues && (
        <UfinetButton
          isDisabled={isLoadingRecalculateCommissionSys}
          className="me-3"
          icon={faCalculator}
          onClick={() => recalculate()}
          content={Translation('RECALCULATE')}
        />
      )}
    </>
  )


  const onSelectionChange = useCallback((values: any[]) => {
    setSelectedValues(values)
  }, [])

  return (
    <>
      {isErrorRecalculate && showToastErrMessage()}
      <UfinetBox>

        <UfinetSectionBox>
          <Table
            dataKey='id'
            enableSearchFilter={false}
            selectedValues={selectedValues}
            onSelectionChange={permissions.canDelete ? onSelectionChange : undefined}
            // onRowEditComplete={permissions.canUpdate ? onRowEditComplete : undefined}
            cols={colsApprovedCommission}
            content={approvedCommssion?.data?.commissions?.map((item: CommissionSystemElement) => ({
              ...item,
              name: `${item.commission.paymentMonth && item.commission.paymentYear ? `${Translation('LIQUIDATE.COL')} ${Translation(item.commission.paymentMonth)} -` : ''} ${item.commission.cutoffMonth && item.commission.cutoffYear ? `${Translation('CLOSEDATE')} ${Translation(item.commission.cutoffMonth)} ${item.commission.cutoffYear}` : ''} `,
              username: item.user.username,
              idService: item.service.idService,
              saleMonth: item.service.saleMonth,
              commissionType: item.commission.commissionType,
              exchangeRate: item.commission.exchangeRate,
              saleYear: item.service.saleYear,
              backlog: item.service.backlog,
              percentageCommission: item.commission.percentageCommission,
              baseAmount: item.commission.baseAmount,
              achievementFactor: item.commission.achievementFactor,
              totalAmount: item.commission.totalAmount,
              authorizationDate: item.authorization.authorizationDate,
              authorizatorName: item.authorization.authorizatorName,
              authorizatorLevel: item.authorization.authorizatorLevel,
              paymentState: item.commission.paymentState,
              paymentMonth: item.commission.paymentMonth,
              paymentYear: item.commission.paymentYear,
              commissionTypePercentage: item.commission.commissionTypePercentage,
              paymentId: item.commission.paymentId,
              idServiceCRM: item.service.idServiceCRM,
              serviceName: item.service.serviceName,
              serviceClient: item.service.serviceClient,
              firstBillingDate: item.service.firstBillingDate,
              id: item.commission.id,
              percentageUser: item.commission.percentageUser,
              managementType: item.service.managementType,
              quoteCode: item.service.quoteCode,
              clientType: item.service.clientType,
            }))}
            actionBodyTemplate={<></>}
            rowsPerPageOptions={[5, 10, 20, 50, 100, 250]}
            emptyMessage={isLoadingApprovedCommision || isLoadingCommissionApprovedSys || isLoadingClientType ? intl.formatMessage({ id: 'LOADING_DOTS' }) : undefined}
            onFilterClear={onFilterClear}
            lazySettings={
              paging && {
                ...paging,
                loading: isLoadingApprovedCommision || isLoadingCommissionApprovedSys || isLoadingClientType,
                onFilter,
                onPage,
                onSort,
              }
            }
            headerButtons={getHeadersButtons()}
          />
        </UfinetSectionBox>
      </UfinetBox >
    </>
  )
}

export { ApprovedCommissionSystemPage }

